/*@ngInject*/
const CurrencyUtil = function (coreMediator, iso4217, preferenceModel) {

    this.getCurrencyFormat = function (currencyCode, displayDollar) {
        let symbol, suffixSymbol, decimalSeparator, groupSeparator, currency;

        currencyCode = currencyCode || 'USD';

        if (preferenceModel.get('view.currencySeparator') === 'false') {
            decimalSeparator = '.';
            groupSeparator = ',';
        } else {
            decimalSeparator = ',';
            groupSeparator = '.';
        }

        currency = iso4217.getCurrencyByCode(currencyCode);

        if (displayDollar) {
            currency = iso4217.getCurrencyByCode('USD');
            symbol = currency.symbol; // get symbol from iso lib
            suffixSymbol = false;
        } else if (preferenceModel.get('view.currencyDisplayFormat') === 'false' && displayDollar !== false) {
            symbol = currency.symbol; // get symbol from iso lib
            suffixSymbol = false;
        } else if (displayDollar !== false) {
            symbol = ' ' + currencyCode;
            suffixSymbol = true;
        } else {
            symbol = '';
            suffixSymbol = false;
        }


        return {
            symbol: symbol,
            suffixSymbol: suffixSymbol,
            customFormat: {'DECIMAL_SEP': decimalSeparator, 'GROUP_SEP': groupSeparator}
        };
    };
};

angular.module('umCore')
    .service('currencyUtil', CurrencyUtil);
